import React from "react";

interface DialogContext {
  onClose?: () => void;
  closeDisabled?: boolean;
}

export default React.createContext<DialogContext>({});
